{
  "header": "تفاصيل الأصل",
  "subtitle": "الأصل المرفق بشاحنتك (مقطورة، حاوية، إلخ).",
  "assetType": "نوع الأصل",
  "assetTypePlaceholder": "اختر نوع الأصل",
  "assetId": "معرف الأصل (مثل رقم المقطورة)",
  "assetIdPlaceholder": "مثال: رقم المقطورة، معرف الحاوية، إلخ",
  "remove": "إزالة",
  "addAnother": "إضافة أصل آخر",
  "trailerType": "نوع المقطورة",
  "trailerId": "معرف المقطورة"
}
